import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  Typography,
  Button,
  Divider,
  TextField,
  InputLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Autocomplete,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  DialogActions,
  Stack,
  Snackbar,
  OutlinedInput,
  InputAdornment,
  Alert,
  Checkbox,
  Tab,
  Tabs,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import FormHelperText from "@mui/material/FormHelperText";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import _debounce from "lodash/debounce";
import Screeningquestion from "./Screeningquestion";
import Cookies from "js-cookie";
import ModalLoadingOverlay, {
  modalLoadingContainerSx,
} from "./ModalLoadingOverlay";

const editorConfig = {
  toolbar: {
    items: [
      "heading",
      "|",
      "bold",
      "italic",
      "bulletedList",
      "numberedList",
      "blockQuote",
      "insertTable",
      "undo",
      "redo",
    ],
  },
  placeholder: "Write the Description here...",
};

const keyResponsibilitiesEditorConfig = {
  ...editorConfig,
  placeholder: "List key responsibilities...",
};

const myTypes = {
  Hire: "H",
  Contract: "C",
  "Contract to Hire": "C2H",
  Freelance: "F",
};
const myTypesReverse = {
  H: "Hire",
  C: "Contract",
  C2H: "Contract to Hire",
  F: "Freelance",
};

const TABS = ["Basic Details", "Skills & Location", "Job Description"];

const sectionLabel = (text) => (
  <Typography sx={{ fontWeight: 500, fontSize: "16px", color: "#000" }}>
    {text}
  </Typography>
);

const fieldLabel = (text, required = false) => (
  <Typography
    sx={{ fontSize: "14px", fontWeight: 400, color: "#000", mb: 0.5 }}
  >
    {text}
    {required && <span style={{ color: "#ef4444", marginLeft: 2 }}>*</span>}
  </Typography>
);

const cancelBtnSx = {
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  fontWeight: 500,
  fontSize: "12px",
  borderRadius: "16px",
  minWidth: "90px",
  minHeight: "32px",
  px: 1.5,
  py: 1,
  backgroundColor: "#F8F9FB",
  color: "#6B7280",
  border: "1px solid #D0D5DD",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: "#F2F4F7",
    border: "1px solid #C3C9D4",
    boxShadow: "none",
  },
};
const primaryBtnSx = {
  backgroundColor: "#3F95EA",
  textTransform: "uppercase",
  borderRadius: "8px",
  textTransform: "none",
  fontWeight: 500,
  minWidth: "90px",
  minHeight: "32px",
  px: 1.5,
  py: 1,
  fontSize: "12px",
  "&:hover": { backgroundColor: "#328be4" },
};

const Createjobdrawer = ({
  editFlag,
  jobId,
  open,
  onClose,
  isDrawerOpen,
  setDrawerOpen,
  toggleDrawer,
  setIsSuccess,
  isEdit,
  setIsEdit,
  disableNavigation = false,
}) => {
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [completedSteps, setCompletedSteps] = useState(new Set());
  const [openPost, setOpenPost] = useState(false);
  const [skills, setSkills] = useState([]);
  const [editorData, setEditorData] = useState("");
  const [keyResponsibilitiesData, setKeyResponsibilitiesData] = useState("");
  const [jobtitle, setJobtitle] = useState("");
  const [jobopenings, setJobopenings] = useState("");
  const [duration, setJobduration] = useState("");
  const [rate, setRate] = useState("");
  const [salary, setSalary] = useState("");
  const [minexp, setMinexp] = useState("");
  const [maxexp, setMaxexp] = useState("");
  const [singleworkmode, setSingleworkmode] = useState("On-Site");
  const [category, setCategory] = useState([]);
  const [singleCategory, setSingleCategory] = useState("");
  const [jobType, setJobType] = useState("");
  const [workmode, setWorkmode] = useState([]);
  const [states, setStates] = useState([]);
  const [singlestate, setSingleState] = useState("");
  const [allCities, setAllCities] = useState([]);
  const [cities, setCities] = useState([]);
  const [singlecities, setsinglecities] = useState("");
  const [notes, setNotes] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [jobTitleError, setJobTitleError] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [companyError, setcompanyError] = useState("");
  const [branchError, setbranchError] = useState("");
  const [jobtypeError, setjobtypeError] = useState("");
  const [minexpError, setminexpError] = useState("");
  const [descriptionError, setdescriptionError] = useState("");
  const [skillsError, setskillError] = useState("");
  const [stateError, setstateError] = useState("");
  const [cityError, setcityError] = useState("");
  const { id } = useParams();
  const [maxexpError, setMaxexpError] = useState("");
  const [equalityError, setEqualityError] = useState("");
  const [cityarr, setcityarr] = useState([]);
  const [shouldRerunEffect, setShouldRerunEffect] = useState(false);
  const [SkillsOption, setSkillsOption] = useState([]);
  const [Logo, setLogo] = useState("");
  const [datemodified, setDateModified] = useState("");
  const [disableflag, setDisableFlag] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [formData, setFormData] = useState([]);
  const [emptyQuestionIndices, setEmptyQuestionIndices] = useState([]);
  const [newerror, setnewerror] = useState([]);
  const [company, setcompany] = useState("");
  const [companyoptions, setcompanyoptions] = useState([]);
  const [company_name, setcompany_name] = useState("");
  const [branchOption, setbranchOption] = useState([]);
  const [branch, setbranch] = useState("");
  const [branch_name, setbranch_name] = useState("");
  const [isPublic, setIsPublic] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isBranchManaged, setIsBranchManaged] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();

  const isRemote = singleworkmode === "Remote";

  const resetForm = () => {
    setSingleCategory("");
    setCategoryError("");
    setcompany("");
    setcompanyError("");
    setbranchError("");
    setJobtitle("");
    setJobTitleError("");
    setJobType("");
    setjobtypeError("");
    setJobduration("");
    setJobopenings("");
    setRate("");
    setSalary("");
    setMaxexp("");
    setMinexp("");
    setminexpError("");
    setMaxexpError("");
    setSingleState("");
    setstateError("");
    setsinglecities("");
    setcityError("");
    setSkills([]);
    setskillError("");
    setEditorData("");
    setKeyResponsibilitiesData("");
    setdescriptionError("");
    setNotes("");
    setIsChecked(false);
    setbranch("");
    setbranchOption([]);
    setIsBranchManaged(null);
    setActiveStep(0);
    setCompletedSteps(new Set());
    setOpenPost(false);
  };

  const handlePublicChange = (e) => setIsPublic(e.target.checked);
  const handleChange = (e) => setIsChecked(e.target.checked);
  const handleJobTitleBlur = () => {
    if (jobtitle.length > 60) setJobTitleError("Maximum 60 characters allowed");
    else setJobTitleError("");
  };

  useEffect(() => {
    if (editFlag || shouldRerunEffect) {
      axios
        .get(`job-info/${jobId}`, {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        })
        .then((response) => {
          setDisableFlag(response.data.message.hasAnyoneApplied);
          const data = response.data.message.jobInfoResult[0];
          const search = data.city ? data.city.split("(")[0].trim() : "";
          axios
            .post(process.env.REACT_APP_JOBEZEURL + "/state-city/list", { search })
            .then((response) => {
              const list = response.data.message || [];
              if (data.city) {
                const cityList = list.filter(
                  (item) => item?.valueType === "city",
                );
                setCities(cityList);
                setcityarr(cityList.map((e) => e.value));
              } else {
                setStates(
                  list.filter((item) => item?.valueType === "state"),
                );
              }
            });
          setSkills(data?.skills ? data?.skills : []);
          setEditorData(data.description);
          setKeyResponsibilitiesData(data.key_responsibilities || "");
          setJobtitle(data.title);
          setJobopenings(data.openings);
          setRate(data.rate);
          setSalary(data.salary);
          setMinexp(data.min_experience);
          setMaxexp(data.max_experience);
          setSingleworkmode(data.workmode);
          setSingleCategory(data.role);
          setcompany(data.company_id);
          setbranch(data.branch_id ? data.branch_id : "");
          setbranch_name(data.branch_name);
          setIsPublic(data.isPublic === 1);
          setcompany_name(data.name);
          setJobType(myTypesReverse[data.type]);
          setSingleState(data.state);
          setNotes(data.notes);
          setJobduration(data.duration);
          setsinglecities(data.city);
          setLogo(data.logo);
          setIsChecked(data.cover_letter_required);
          setDateModified(data.date_modified);
          setCompletedSteps(new Set([0, 1, 2]));
        })
        .catch((err) => {});
    }
  }, [isEdit, open]);

  useEffect(() => {
    axios
      .get(`all-category`, {
        headers: {
          authorization:
            Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
        },
      })
      .then((response) => {
        setCategory(response.data.message.category);
        setWorkmode(response.data.message.workmode);
      })
      .catch((err) => console.error(err));
    axios
      .post(process.env.REACT_APP_JOBEZEURL+ "/state-city/list", { search: "" })
      .then((response) => {
        const list = response.data.message || [];
        setStates(list.filter((item) => item?.valueType === "state"));
        setAllCities(list.filter((item) => item?.valueType === "city"));
        setCities([]);
        setcityarr([]);
      })
      .catch((err) => console.error(err));
  }, [isEdit]);

  useEffect(() => {
    if (!singlestate) {
      setCities([]);
      setcityarr([]);
      return;
    }

    if (!allCities.length) return;

    const selectedState = states.find((state) => state.value === singlestate);
    const filteredCities = selectedState?.stateCode
      ? allCities.filter((city) => city.stateCode === selectedState.stateCode)
      : [];

    setCities(filteredCities);
    setcityarr(filteredCities.map((city) => city.value));
  }, [allCities, singlestate, states]);

  const handlejobtitle = (e) => {
    const value = e.target.value;
    const formatted =
      value.length > 0 ? value.charAt(0).toUpperCase() + value.slice(1) : value;
    if (formatted.length > 60)
      setJobTitleError("Maximum 60 characters allowed");
    else setJobTitleError("");
    setJobtitle(formatted);
  };

  const handlejobopenings = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value === "") {
      setJobopenings("");
      return;
    }
    const intValue = parseInt(value, 10);
    if (intValue > 1000) setJobopenings("1000");
    else setJobopenings(intValue.toString());
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const sanitized = e.clipboardData.getData("text").replace(/\D/g, "");
    if (!sanitized) {
      setJobopenings("");
      return;
    }
    const intValue = parseInt(sanitized, 10);
    setJobopenings(intValue > 1000 ? "1000" : intValue.toString());
  };

  const handleNumericKeyDown = (e) => {
    const allowedKeys = [
      "Backspace",
      "Delete",
      "Tab",
      "Escape",
      "Enter",
      "ArrowLeft",
      "ArrowRight",
      "Home",
      "End",
    ];
    if (
      allowedKeys.includes(e.key) ||
      ((e.ctrlKey || e.metaKey) && ["a", "c", "v", "x"].includes(e.key.toLowerCase()))
    )
      return;
    if (!/^\d$/.test(e.key)) e.preventDefault();
  };

  const handleduration = (e) => {
    if (e.target.value.length <= 20) setJobduration(e.target.value);
  };
  const handlerate = (e) => {
    const value =
      e.target.value.startsWith(".") ? `0${e.target.value}` : e.target.value;
    if (/^\d{0,10}(\.\d{0,2})?$/.test(value)) setRate(value);
  };
  const handlesalary = (e) =>
    setSalary(e.target.value.replace(/[^0-9]/g, "").substring(0, 10));

  const handleminexp = (e) => {
    const value = e.target.value.replace(/^0+/, "0");
    if (
      value === "" ||
      (/^0$|^[1-9]\d*$/.test(value) &&
        parseInt(value, 10) >= 0 &&
        parseInt(value, 10) <= 40)
    )
      setMinexp(value);
  };

  const handlemaxexp = (e) => {
    const value = e.target.value;
    if (
      value === "" ||
      (/^\d+$/.test(value) &&
        parseInt(value, 10) >= 1 &&
        parseInt(value, 10) <= 40)
    )
      setMaxexp(value);
  };

  const handleBlurMinExp = () => {
    if (parseInt(minexp, 10) === parseInt(maxexp, 10))
      setminexpError("Cannot be equal to max experience.");
    else setminexpError("");
  };

  const handleBlurMaxExp = () => {
    if (parseInt(maxexp, 10) < parseInt(minexp, 10))
      setMaxexpError("Cannot be less than min experience.");
    else if (parseInt(maxexp, 10) === parseInt(minexp, 10))
      setMaxexpError("Cannot be equal to min experience.");
    else setMaxexpError("");
  };

  const singlehandleworkmode = (e) => {
    setSingleworkmode(e.target.value);
    // ✅ Remote select hone par city/state errors aur values clear karo
    if (e.target.value === "Remote") {
      setSingleState("");
      setsinglecities("");
      setstateError("");
      setcityError("");
    }
  };

  const handleCategory = (e) => {
    setSingleCategory(e.target.value);
    setCategoryError("");
  };
  const handlecompany = (e) => {
    const tmplogo = companyoptions.find((o) => o.id === e.target.value)?.logo;
    setLogo(tmplogo);
    setcompany(e.target.value);
    setbranch("");
    setbranchOption([]);
    setbranchError("");
    setIsBranchManaged(null);
    setcompanyError("");
  };
  const handleBranch = (e) => {
    setbranch(e.target.value);
    setbranchError("");
  };

  useEffect(() => {
    if (company) {
      axios
        .post(
          `/list-of-branches/${company}`,
          {},
          {
            headers: {
              authorization:
                Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
            },
          },
        )
        .then((res) => setbranchOption(res.data.message.branchListResponse))
        .catch((err) => console.error(err));
    }
  }, [company]);

  useEffect(() => {
    axios
      .post(
        `/list-of-companies`,
        {},
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((res) => setcompanyoptions(res.data.message.companyListResponse))
      .catch((err) => console.error(err));
  }, [editFlag]);

  const handleJobType = (e) => {
    const selectedType = e.target.value;
    setJobType(selectedType);
    if (["Contract", "Contract to Hire", "Freelance"].includes(selectedType))
      setSalary("");
    if (selectedType === "Hire") setJobduration("");
    setjobtypeError("");
  };

  const handleStates = (e) => {
    setSingleState(e.target.value);
    setsinglecities("");
    setstateError("");
  };
  const handleCities = (e) => {
    setsinglecities(e.target.value);
    setcityError("");
  };

  const handleSkillChange = (_, newValues) => {
    const labels = newValues?.map((item) =>
      typeof item === "object" ? item.label : item,
    );
    const uniqueSkills = Array.from(
      new Set(
        labels
          ?.filter((s) => s.trim() !== "")
          .map((s) => s.trim().toLowerCase()),
      ),
    );
    setSkills(uniqueSkills);
    setskillError("");
  };

  const availableOptions = SkillsOption.filter(
    (o) => !skills.includes(o.label.toLowerCase()),
  );

  const renderTags = (value, getTagProps) => {
    if (!value || value.length === 0) return null;
    return value.map((option, index) => (
      <Chip
        key={index}
        variant="filled"
        label={option}
        {...getTagProps({ index })}
        onDelete={() => setSkills(skills?.filter((s) => s !== option))}
      />
    ));
  };

  const handlenotes = (e) => setNotes(e.target.value);

  const errorFieldRefs = {
    branch: useRef(null),
    jobtitle: useRef(null),
    category: useRef(null),
    jobType: useRef(null),
    skills: useRef(null),
    state: useRef(null),
    city: useRef(null),
    maxExp: useRef(null),
    minExp: useRef(null),
  };

  const hanldeSkillInputChange = _debounce((value) => skillssearch(value), 415);

  const skillssearch = async (val) => {
    try {
      if (val) {
        const response = await axios.get(
          process.env.REACT_APP_BASEURL + `/all-skills?search=${val}`,
          {
            headers: {
              authorization:
                Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
            },
          },
        );
        setSkillsOption(response.data.message);
      }
    } catch (error) {
      console.error("Error", error);
    }
  };

  const validateStep1 = () => {
    let hasError = false;
    if (jobtitle.trim() === "") {
      setJobTitleError("Job Title is required.");
      hasError = true;
    } else setJobTitleError("");
    if (singleCategory === "") {
      setCategoryError("Category is required.");
      hasError = true;
    } else setCategoryError("");
    if (company === "") {
      setcompanyError("Company is required.");
      hasError = true;
    } else setcompanyError("");
    if (branch === "" && isBranchManaged === 1) {
      setbranchError("Branch is required.");
      hasError = true;
    } else setbranchError("");
    if (jobType === "") {
      setjobtypeError("Job Type is required");
      hasError = true;
    } else setjobtypeError("");
    if (maxexp === "" && minexp === "") {
      setMaxexpError("Required.");
      setminexpError("Required.");
      hasError = true;
    } else if (minexp === "") {
      setminexpError("Required.");
      hasError = true;
    } else if (maxexp === minexp) {
      setminexpError("Cannot be equal to max.");
      setMaxexpError("Cannot be equal to min.");
      hasError = true;
    } else if (parseInt(minexp) > parseInt(maxexp)) {
      setminexpError("Cannot be greater than max.");
      setMaxexpError("Cannot be less than min.");
      hasError = true;
    } else {
      setminexpError("");
      setMaxexpError("");
    }
    return !hasError;
  };

  const validateStep2 = () => {
    let hasError = false;
    if (skills?.length === 0) {
      setskillError("Skills are required");
      hasError = true;
    } else if (skills.length < 5) {
      setskillError("Minimum 5 skills required");
      hasError = true;
    } else setskillError("");

    // ✅ Remote mode mein state/city validation skip karo
    if (!isRemote) {
      if (!singlestate || Object.keys(singlestate).length === 0) {
        setstateError("State is required");
        hasError = true;
      } else setstateError("");
      if (!cityarr.includes(singlecities)) {
        setcityError("City is required");
        hasError = true;
      } else setcityError("");
    } else {
      setstateError("");
      setcityError("");
    }

    return !hasError;
  };

  const validateStep3 = () => {
    let hasError = false;
    setnewerror(emptyQuestionIndices);
    if (editorData.trim() === "") {
      setdescriptionError("Description is required.");
      hasError = true;
    } else setdescriptionError("");
    if (emptyQuestionIndices.length > 0) hasError = true;
    return !hasError;
  };

  const handleNext = () => {
    if (activeStep === 0 && !validateStep1()) return;
    if (activeStep === 1 && !validateStep2()) return;
    if (activeStep < TABS.length - 1) {
      setCompletedSteps((prev) => new Set([...prev, activeStep]));
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) setActiveStep((prev) => prev - 1);
  };
  const handleTabClick = (index) => {
    if (index <= activeStep || completedSteps.has(index - 1))
      setActiveStep(index);
  };
  const handleOpenPost = () => {
    if (!validateStep3()) return;
    setOpenPost(true);
  };

  const handlePostJob = () => {
    setLoading(true);
    axios
      .post(
        `create-job`,
        {
          category: singleCategory,
          job_title: jobtitle,
          job_type: myTypes[jobType],
          no_of_opening: jobopenings == "0" || !jobopenings ? 1 : jobopenings,
          duration,
          rate,
          salary,
          min_exp: minexp ? Number(minexp) : null,
          max_exp: maxexp ? Number(maxexp) : null,
          workmode: singleworkmode,
          // ✅ Remote mode mein city/state null bhejo
          city: isRemote ? null : singlecities,
          state: isRemote ? null : singlestate,
          job_desc: editorData,
          key_responsibilities: keyResponsibilitiesData,
          skills,
          internal_notes: notes,
          companyId: company,
          branch_id: branch ? branch : null,
          cover_letter_required: isChecked ? 1 : 0,
          questionsArray: formData,
          isPublic: isPublic ? 1 : 0,
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        if (response.data.status === 200) {
          setLoading(false);
          setOpenSnackbar(true);
          setSnackbarMessage("Job Created Successfully");
          resetForm();
          if (setIsSuccess) setIsSuccess(true);
          if (onClose) onClose();
          if (!disableNavigation) {
            setTimeout(() => navigate("/jobOrders?page=1"), 1000);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleEditJob = () => {
    setLoading(true);
    axios
      .post(
        `update-job/${jobId}`,
        {
          category: singleCategory,
          job_title: jobtitle,
          job_type: myTypes[jobType],
          no_of_opening: jobopenings == "0" || !jobopenings ? 1 : jobopenings,
          duration,
          rate,
          salary,
          min_exp: minexp ? Number(minexp) : null,
          max_exp: maxexp ? Number(maxexp) : null,
          workmode: singleworkmode,
          // ✅ Remote mode mein city/state null bhejo
          city: isRemote ? null : singlecities,
          state: isRemote ? null : singlestate,
          job_desc: editorData,
          key_responsibilities: keyResponsibilitiesData,
          skills,
          internal_notes: notes,
          cover_letter_required: isChecked ? 1 : 0,
          original_date_modified: datemodified,
          questionsArray: formData,
          companyId: company,
          branch_id: branchOption.length > 0 ? branch : null,
          isPublic: isPublic ? 1 : 0,
        },
        {
          headers: {
            authorization:
              Cookies.get("_secure_ARJ_") || Cookies.get("_secure_ref"),
          },
        },
      )
      .then((response) => {
        if (response.data.status === 200) {
          setLoading(false);
          setOpenSnackbar(true);
          setSnackbarMessage("Job Edited Successfully");
          if (setIsSuccess) setIsSuccess(true);
          if (onClose) onClose();
          if (!disableNavigation) {
            setTimeout(
              () => navigate(`/jobOrders/${jobId}`, { state: { value: 0 } }),
              1000,
            );
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        setSnackbarMessage(err.response.data.error.error);
        setOpenSnackbar(true);
      });
  };

  const handleEditorChange = (event, editor) => {
    setEditorData(editor.getData());
    setdescriptionError("");
  };

  const handleKeyResponsibilitiesChange = (event, editor) => {
    setKeyResponsibilitiesData(editor.getData());
  };

  const handleCancelData = () => {
    resetForm();
    if (onClose) onClose();
    if (disableNavigation) return;
    if (editFlag) navigate(`/jobOrders/${jobId}`);
    else navigate("/jobOrders?page=1");
  };

  const handleButtonClick = () => {
    if (!loading) {
      setLoading(true);
      if (editFlag) handleEditJob();
      else handlePostJob();
    }
  };

  useEffect(() => {
    const selectedCompany = companyoptions.find((c) => c.id === company);
    if (selectedCompany) setIsBranchManaged(selectedCompany.is_branch_managed);
    else setIsBranchManaged(null);
  }, [company, companyoptions]);

  useEffect(() => {
    const cname = companyoptions?.filter((d) => d.company_id == company)[0]
      ?.name;
    const bname = branchOption?.filter((d) => d.branch_id == branch)[0]?.name;
    setcompany_name(cname);
    setbranch_name(bname);
  }, [company, branch]);

  // ── Preview ────────────────────────────────────────────────────────────────
  const previewContent = (
    <Box sx={{ p: 2.5 }}>
      <Box sx={{ display: "flex", gap: 2, mb: 2, alignItems: "center" }}>
        {Logo && (
          <img
            src={Logo}
            style={{
              width: "64px",
              height: "64px",
              objectFit: "cover",
              borderRadius: "8px",
            }}
            alt="logo"
          />
        )}
        <Box>
          <Typography
            sx={{ fontSize: "18px", fontWeight: 700, color: "#111827" }}
          >
            {jobtitle}
          </Typography>
          <Typography sx={{ fontSize: "14px", color: "#6B7280" }}>
            {company_name}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ mb: 2 }} />
      <Box
        sx={{ backgroundColor: "#EBF4FD", borderRadius: "10px", p: 2, mb: 2 }}
      >
        <Typography
          sx={{ fontSize: "15px", fontWeight: 600, color: "#111827", mb: 1.5 }}
        >
          Highlights
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
          {/* ✅ Preview mein bhi Remote hone par city/state nahi dikhao */}
          {!isRemote && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <PlaceOutlinedIcon sx={{ fontSize: "18px", color: "#3F95EA" }} />
              <Typography variant="body2" color="#374151">
                {singlecities}, {singlestate}
              </Typography>
            </Box>
          )}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WorkOutlineOutlinedIcon
              sx={{ fontSize: "18px", color: "#3F95EA" }}
            />
            <Typography variant="body2" color="#374151">
              {minexp < 1 && !maxexp ? (
                "Entry-Level"
              ) : (
                <>
                  {minexp >= 0 ? (
                    <>
                      {minexp}
                      {!maxexp ? "+" : ""}
                    </>
                  ) : null}
                  {maxexp ? ` - ${maxexp}` : ""} years
                </>
              )}
            </Typography>
          </Box>
          {[
            ["Type:", jobType],
            ["Mode:", singleworkmode],
            ["Role:", singleCategory],
          ].map(([label, val]) => (
            <Box
              key={label}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Typography variant="body2" color="#6B7280">
                {label}
              </Typography>
              <Typography variant="body2" fontWeight={600} color="#374151">
                {val}
              </Typography>
            </Box>
          ))}
          {salary && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" color="#6B7280">
                Salary:
              </Typography>
              <Typography variant="body2" fontWeight={600} color="#374151">
                ${salary}/yr
              </Typography>
            </Box>
          )}
          {rate && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" color="#6B7280">
                Rate:
              </Typography>
              <Typography variant="body2" fontWeight={600} color="#374151">
                ${rate}/hr
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography
          sx={{ fontSize: "14px", fontWeight: 700, color: "#111827", mb: 1 }}
        >
          About the Job
        </Typography>
        <Box
          sx={{ fontSize: "13px", color: "#374151", lineHeight: 1.6 }}
          dangerouslySetInnerHTML={{ __html: editorData || "NA" }}
        />
      </Box>
      {keyResponsibilitiesData &&
        keyResponsibilitiesData.replace(/<[^>]*>/g, "").trim() !== "" && (
          <Box sx={{ mb: 2 }}>
            <Typography
              sx={{ fontSize: "14px", fontWeight: 700, color: "#111827", mb: 1 }}
            >
              Key Responsibilities
            </Typography>
            <Box
              sx={{ fontSize: "13px", color: "#374151", lineHeight: 1.6 }}
              dangerouslySetInnerHTML={{ __html: keyResponsibilitiesData }}
            />
          </Box>
        )}
      <Divider sx={{ mb: 2 }} />
      <Box sx={{ mb: 2 }}>
        <Typography
          sx={{ fontSize: "14px", fontWeight: 700, color: "#111827", mb: 1 }}
        >
          Skills Required
        </Typography>
        <Stack direction="row" flexWrap="wrap" gap={1}>
          {skills?.map((item, index) => (
            <Chip
              key={index}
              label={item}
              size="small"
              sx={{
                backgroundColor: "#DFEBF8",
                color: "#000",
                fontSize: "12px",
              }}
            />
          ))}
        </Stack>
      </Box>
      {isChecked && (
        <Box sx={{ mb: 2 }}>
          <Typography sx={{ fontSize: "13px", color: "#6B7280" }}>
            ✓ Cover Letter Required
          </Typography>
        </Box>
      )}
      <Box>
        <Typography sx={{ fontSize: "13px", color: "#6B7280" }}>
          Visibility: <b>{isPublic ? "Public" : "Internal"}</b>
        </Typography>
      </Box>
    </Box>
  );

  // ── Step 1 ─────────────────────────────────────────────────────────────────
  const step1Content = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: 2.5 }}>
      {sectionLabel("Basic Details")}
      <Box sx={{ display: "flex", gap: 1.5 }}>
        <FormControl size="small" fullWidth error={!!categoryError}>
          {fieldLabel("Category", true)}
          <Select
            value={singleCategory}
            size="small"
            displayEmpty
            onChange={handleCategory}
            renderValue={(v) =>
              v || <span style={{ color: "#9ca3af" }}>Select</span>
            }
          >
            {category?.map((item, index) => (
              <MenuItem key={index} value={item?.name}>
                {item?.name}
              </MenuItem>
            ))}
          </Select>
          {categoryError && <FormHelperText>{categoryError}</FormHelperText>}
        </FormControl>
        <FormControl size="small" fullWidth error={!!companyError}>
          {fieldLabel("Company", true)}
          <Select
            value={company}
            size="small"
            displayEmpty
            onChange={handlecompany}
            renderValue={(v) =>
              companyoptions.find((o) => o.id === v)?.name || (
                <span style={{ color: "#9ca3af" }}>Select</span>
              )
            }
          >
            {companyoptions.map((opt) => (
              <MenuItem key={opt.id} value={opt.id}>
                {opt.name}
              </MenuItem>
            ))}
          </Select>
          {companyError && <FormHelperText>{companyError}</FormHelperText>}
        </FormControl>
      </Box>

      {branchOption.length > 0 && (
        <FormControl size="small" fullWidth>
          {fieldLabel("Branch")}
          <Select
            value={branch}
            size="small"
            error={!!branchError}
            displayEmpty
            onChange={handleBranch}
            renderValue={(v) =>
              branchOption.find((o) => o.id === v)?.branch_name || (
                <span style={{ color: "#9ca3af" }}>Select</span>
              )
            }
          >
            {branchOption.map((opt) => (
              <MenuItem key={opt.id} value={opt.id}>
                {opt.branch_name}
              </MenuItem>
            ))}
          </Select>
          {branchError && <FormHelperText error>{branchError}</FormHelperText>}
        </FormControl>
      )}

      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Box sx={{ flex: 1 }}>
          {fieldLabel("Job Title", true)}
          <TextField
            size="small"
            fullWidth
            placeholder="Enter job title"
            variant="outlined"
            value={jobtitle}
            error={!!jobTitleError}
            helperText={jobTitleError}
            onChange={handlejobtitle}
            onBlur={handleJobTitleBlur}
          />
        </Box>
        <FormControl
          size="small"
          fullWidth
          error={!!jobtypeError}
          sx={{ flex: 1 }}
        >
          {fieldLabel("Job Type", true)}
          <Select
            value={jobType}
            size="small"
            displayEmpty
            onChange={handleJobType}
            renderValue={(v) =>
              v || <span style={{ color: "#9ca3af" }}>Select</span>
            }
          >
            <MenuItem value="Hire">Hire</MenuItem>
            <MenuItem value="Contract">Contract</MenuItem>
            <MenuItem value="Contract to Hire">Contract to Hire</MenuItem>
            <MenuItem value="Freelance">Freelance</MenuItem>
          </Select>
          {jobtypeError && <FormHelperText>{jobtypeError}</FormHelperText>}
        </FormControl>
      </Box>

      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Box sx={{ flex: 1 }}>
          {fieldLabel("No. of Jobs/Openings")}
          <TextField
            size="small"
            fullWidth
            placeholder="Enter number of openings"
            variant="outlined"
            value={jobopenings}
            onChange={handlejobopenings}
            onKeyDown={handleNumericKeyDown}
            onPaste={handlePaste}
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          {fieldLabel("Duration")}
          <TextField
            size="small"
            fullWidth
            placeholder="Enter contract duration"
            variant="outlined"
            value={duration}
            onChange={handleduration}
            disabled={jobType === "Hire"}
          />
        </Box>
      </Box>

      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Box sx={{ flex: 1 }}>
          {fieldLabel("Rate/Hour ($)")}
          <FormControl fullWidth size="small">
            <OutlinedInput
              id="rate"
              size="small"
              startAdornment={
                <InputAdornment position="start">$</InputAdornment>
              }
              value={rate}
              onChange={handlerate}
              placeholder="Enter hourly rate"
              inputProps={{ inputMode: "decimal" }}
            />
          </FormControl>
        </Box>
        <Box sx={{ flex: 1 }}>
          {fieldLabel("Salary/Annum ($)")}
          <FormControl fullWidth size="small">
            <OutlinedInput
              id="salary"
              size="small"
              startAdornment={
                <InputAdornment position="start">$</InputAdornment>
              }
              value={salary}
              onChange={handlesalary}
              placeholder="Enter annual salary"
              disabled={jobType !== "Hire"}
            />
          </FormControl>
        </Box>
      </Box>

      <Divider />

      {sectionLabel("Experience")}
      <Box sx={{ display: "flex", gap: 1.5 }}>
        <Box sx={{ flex: 1 }}>
          {fieldLabel("Minimum Experience", true)}
          <TextField
            size="small"
            fullWidth
            placeholder="Enter minimum experience"
            variant="outlined"
            value={minexp}
            error={!!minexpError}
            helperText={minexpError || ""}
            onChange={handleminexp}
            onBlur={handleBlurMinExp}
            onFocus={() => setminexpError("")}
            sx={{ "& .MuiFormHelperText-root": { fontSize: "11px", mt: 0.3 } }}
          />
        </Box>
        <Box sx={{ flex: 1 }}>
          {fieldLabel("Maximum Experience", true)}
          <TextField
            size="small"
            fullWidth
            placeholder="Enter maximum experience"
            variant="outlined"
            value={maxexp}
            error={!!maxexpError || !!equalityError}
            helperText={maxexpError || equalityError || ""}
            onChange={handlemaxexp}
            onBlur={handleBlurMaxExp}
            onFocus={() => setMaxexpError("")}
            sx={{ "& .MuiFormHelperText-root": { fontSize: "11px", mt: 0.3 } }}
          />
        </Box>
      </Box>
    </Box>
  );

  // ── Step 2 ─────────────────────────────────────────────────────────────────
  const step2Content = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: 2.5 }}>
      <Box sx={{ display: "flex", gap: 4, alignItems: "flex-start" }}>
        <Box>
          {sectionLabel("Work Mode")}
          <RadioGroup
            value={singleworkmode}
            onChange={singlehandleworkmode}
            row
          >
            {workmode?.map((item, index) => (
              <FormControlLabel
                key={index}
                sx={{ mr: 1 }}
                value={item?.name}
                control={<Radio size="small" />}
                label={<Typography fontSize="13px">{item?.name}</Typography>}
              />
            ))}
          </RadioGroup>
        </Box>
        <Box>
          {sectionLabel("Visibility")}
          <FormControlLabel
            control={
              <Checkbox
                checked={isPublic}
                onChange={handlePublicChange}
                size="small"
              />
            }
            label={<Typography fontSize="13px">Public</Typography>}
          />
        </Box>
      </Box>
      {/* Remote mode mein Location section bilkul hide karo */}
      {!isRemote && (
        <>
          {sectionLabel("Location")}
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <FormControl size="small" fullWidth error={!!stateError}>
              {fieldLabel("State", true)}
              <Select
                value={singlestate}
                size="small"
                displayEmpty
                onChange={handleStates}
                renderValue={(v) =>
                  v || <span style={{ color: "#9ca3af" }}>Select</span>
                }
              >
                {states?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
              {stateError && <FormHelperText>{stateError}</FormHelperText>}
            </FormControl>
            <FormControl size="small" fullWidth error={!!cityError}>
              {fieldLabel("City", true)}
              <Select
                value={singlecities}
                size="small"
                displayEmpty
                onChange={handleCities}
                renderValue={(v) =>
                  v || <span style={{ color: "#9ca3af" }}>Select</span>
                }
              >
                {cities?.map((item, index) => (
                  <MenuItem key={index} value={item.value}>
                    {item.value}
                  </MenuItem>
                ))}
              </Select>
              {cityError && <FormHelperText>{cityError}</FormHelperText>}
            </FormControl>
          </Box>
          <Divider sx={{ my: 0.5 }} />
        </>
      )}

      {fieldLabel("Skills", true)}
      <Autocomplete
        multiple
        freeSolo
        filterSelectedOptions
        id="tags-standard"
        value={skills ? skills : []}
        onChange={handleSkillChange}
        onInputChange={(event, newInputValue) =>
          hanldeSkillInputChange(newInputValue)
        }
        options={availableOptions?.map((ele) => ele.label)}
        renderTags={renderTags}
        sx={{
          "& .MuiOutlinedInput-root": {
            alignItems: "flex-start",
            minHeight: "72px",
            py: "6px",
          },
          "& .MuiAutocomplete-tag": {
            my: "2px",
          },
          "& .MuiAutocomplete-input": {
            minWidth: "160px !important",
            py: "4px !important",
          },
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            fullWidth
            size="small"
            placeholder="Enter skills"
            error={!!skillsError}
            helperText={skillsError}
            onFocus={() => setskillError("")}
          />
        )}
      />

      <Divider sx={{ my: 0.5 }} />

      <FormControlLabel
        control={
          <Checkbox checked={isChecked} onChange={handleChange} size="small" />
        }
        label={<Typography fontSize="13px">Cover Letter Required</Typography>}
      />

      {sectionLabel("Internal Notes")}
      <TextField
        size="small"
        fullWidth
        placeholder="Internal Notes"
        variant="outlined"
        multiline
        rows={3}
        value={notes}
        onChange={handlenotes}
        sx={{
          "& .MuiInputBase-inputMultiline": {
            overflowY: "auto !important",
            maxHeight: "80px",
          },
        }}
      />
    </Box>
  );

  // ── Step 3 ─────────────────────────────────────────────────────────────────
  const step3Content = (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, p: 2.5 }}>
      {fieldLabel("Job Description", true)}
      <Box
        sx={{
          "& .ck-editor__editable": {
            minHeight: "160px !important",
            maxHeight: "160px !important",
            overflowY: "auto !important",
          },
        }}
      >
        <CKEditor
          editor={ClassicEditor}
          data={editorData}
          onChange={handleEditorChange}
          config={editorConfig}
        />
      </Box>
      {descriptionError && (
        <Typography sx={{ color: "#d32f2f", fontSize: "0.75rem", mt: -0.5 }}>
          {descriptionError}
        </Typography>
      )}

      {sectionLabel("Key Responsibilities")}
      <Box
        sx={{
          "& .ck-editor__editable": {
            minHeight: "120px !important",
            maxHeight: "160px !important",
            overflowY: "auto !important",
          },
        }}
      >
        <CKEditor
          editor={ClassicEditor}
          data={keyResponsibilitiesData}
          onChange={handleKeyResponsibilitiesChange}
          config={keyResponsibilitiesEditorConfig}
        />
      </Box>

      <Divider sx={{ my: 0.5 }} />
      {sectionLabel("Screening Questions")}
      <Typography sx={{ fontSize: "12px", color: "#9CA3AF", mt: -1 }}>
        We recommend adding 3 or more questions. Applicants must answer each
        question.
      </Typography>
      <Box>
        <Screeningquestion
          newerror={newerror}
          setnewerror={setnewerror}
          setEmptyQuestionIndices={setEmptyQuestionIndices}
          emptyQuestionIndices={emptyQuestionIndices}
          setFormData={setFormData}
          jobId={jobId}
          disableflag={disableflag}
        />
      </Box>
    </Box>
  );

  const stepContent = [step1Content, step2Content, step3Content];

  return (
    <>
      <Dialog
        open={open ?? true}
        onClose={handleCancelData}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: modalLoadingContainerSx(loading, {
            borderRadius: "12px",
            height: "90vh",
            maxHeight: "90vh",
            display: "flex",
            flexDirection: "column",
            "& .MuiOutlinedInput-root": { borderRadius: "8px" },
            "& .MuiSelect-outlined": { borderRadius: "8px" },
            "& input::placeholder": {
              color: "rgba(106, 120, 133, 0.60)",
              opacity: 1,
            },
            "& textarea::placeholder": {
              color: "rgba(106, 120, 133, 0.60)",
              opacity: 1,
            },
          }),
        }}
      >
        {/* ── Header ── */}
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: "20px",
            py: "8px",
            borderBottom: "1px solid #E5E7EB",
            flexShrink: 0,
          }}
        >
          <Typography
            sx={{ fontSize: "16px", fontWeight: 600, color: "#111827" }}
          >
            {openPost ? "Job Preview" : editFlag ? "Edit Job" : "Create a Job"}
          </Typography>
          <IconButton onClick={handleCancelData} size="small">
            <CloseIcon sx={{ fontSize: "18px", color: "#6B7280" }} />
          </IconButton>
        </DialogTitle>

        {/* ── Tabs ── */}
        {!openPost && (
          <Box
            sx={{
              borderBottom: "1px solid #E5E7EB",
              backgroundColor: "#F9FAFB",
              flexShrink: 0,
            }}
          >
            <Tabs
              value={activeStep}
              onChange={(e, val) => handleTabClick(val)}
              sx={{
                minHeight: "40px",
                px: 2,
                "& .MuiTab-root": {
                  minHeight: "40px",
                  textTransform: "none",
                  fontSize: "13px",
                  fontWeight: 500,
                  color: "#6B7280",
                  px: 1.5,
                },
                "& .Mui-selected": {
                  color: "#3F95EA !important",
                  fontWeight: 600,
                },
                "& .MuiTabs-indicator": { backgroundColor: "#3F95EA" },
              }}
            >
              {TABS.map((tab, index) => (
                <Tab
                  key={index}
                  label={tab}
                  disabled={
                    index > activeStep && !completedSteps.has(index - 1)
                  }
                />
              ))}
            </Tabs>
          </Box>
        )}

        {/* ── Content ── */}
        <DialogContent sx={{ px: 0, py: 0, overflowY: "auto", flex: 1 }}>
          {openPost ? previewContent : stepContent[activeStep]}
        </DialogContent>

        {/* ── Footer ── */}
        <DialogActions
          sx={{
            px: 3,
            py: 1.5,
            gap: 1,
            borderTop: "1px solid rgba(0,0,0,0.12)",
            justifyContent: "flex-end",
            flexShrink: 0,
          }}
        >
          {openPost ? (
            <>
              <Button
                variant="contained"
                onClick={() => setOpenPost(false)}
                sx={cancelBtnSx}
                disableElevation
              >
                Back
              </Button>
              <Button
                variant="contained"
                onClick={handleButtonClick}
                disabled={loading}
                sx={primaryBtnSx}
              >
                {loading ? "Posting..." : "Post"}
              </Button>
            </>
          ) : (
            <>
              <Button
                variant="contained"
                onClick={activeStep === 0 ? handleCancelData : handleBack}
                sx={cancelBtnSx}
                disableElevation
              >
                {activeStep === 0 ? "Cancel" : "Back"}
              </Button>
              <Button
                variant="contained"
                onClick={
                  activeStep === TABS.length - 1 ? handleOpenPost : handleNext
                }
                disabled={
                  activeStep === 0 &&
                  (minexpError.trim() !== "" || maxexpError.trim() !== "")
                }
                sx={primaryBtnSx}
              >
                {activeStep === TABS.length - 1 ? "Preview" : "Next"}
              </Button>
            </>
          )}
        </DialogActions>
        <ModalLoadingOverlay open={loading} />
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={openSnackbar}
        autoHideDuration={3000}
        onClose={() => setOpenSnackbar(false)}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity={
            snackbarMessage === "Job Created Successfully" ||
            snackbarMessage === "Job Edited Successfully"
              ? "success"
              : "error"
          }
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Createjobdrawer;
